export const BASE_ENDPOINT = process.env.REACT_APP_WOLOLO_ENV === 'development' ? 'https://api.dev.talkative.media/v1' : 'https://api.talkative.media/v1'

export const PLANS_ENDPOINT = `${BASE_ENDPOINT}/checkout/plans`
export const CLIENTS_ENDPOINT = `${BASE_ENDPOINT}/checkout/clients`
export const PIPEFY_ENDPOINT = `${BASE_ENDPOINT}/checkout/pipefy`
export const CONTACT_ENDPOINT = `${BASE_ENDPOINT}/contact`
export const LANDPAGE_ENDPOINT = `${BASE_ENDPOINT}/landpage`



// WEBPACK FOOTER //
// ./src/api/endpoint.js